import { MyProgramConstant } from "../constant/my-program.constant";

export class OpenOrderInfoUtil {
  static openOrderInfoPage(orderNo: String): void {
    window.open(MyProgramConstant.urlMyOffice + `/order-management/order-details-inquiry?order-no=${orderNo}&chkLogin=Y`, "_blank");
  }
  
  static openOrderInfoPageNotLogin(orderNo: String): void {
    window.open(`/order-detail-not-login?order-no=${orderNo}&chkLogin=N`, "_blank");
  }

}